(() => {
  let acknowledged = false;
  let syncPending = false;
  const syncOrderConsent = () => {
    document.querySelectorAll('[data-bt-order-checkbox]').forEach(input => {
      input.checked = acknowledged;
    });
    document.querySelectorAll('[data-bt-checkout]').forEach(button => {
      button.disabled = !acknowledged;
    });
    syncPending = false;
  };
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-bt-order-checkbox]')) return;
    acknowledged = event.target.checked;
    event.target.setCustomValidity('');
    syncOrderConsent();
  });
  document.addEventListener('submit', event => {
    if (!event.submitter?.matches('[data-bt-checkout]')) return;
    const input = Array.from(event.target.elements).find(element => element.matches?.('[data-bt-order-checkbox]'));
    if (!input || !input.checked || !acknowledged) {
      event.preventDefault();
      if (input) {
        input.setCustomValidity(input.dataset.error);
        input.reportValidity();
      }
    }
  }, true);
  new MutationObserver(records => {
    if (syncPending || !records.some(record => record.addedNodes.length)) return;
    syncPending = true;
    requestAnimationFrame(syncOrderConsent);
  }).observe(document.body, {childList:true, subtree:true});
  window.addEventListener('pageshow', () => { acknowledged = false; syncOrderConsent(); });
  syncOrderConsent();

  const panel = document.getElementById('bt-cookie-panel');
  const reopen = document.querySelector('[data-bt-cookie-reopen]');
  if (!panel || !reopen) return;
  const errorText = panel.querySelector('.bt-cookie-error');
  const buttons = [...panel.querySelectorAll('[data-bt-cookie-save]')];
  const controls = [...panel.querySelectorAll('[data-bt-cookie]')];
  let privacy;
  let returnFocus;
  const show = () => {
    const consent = privacy.currentVisitorConsent();
    controls.forEach(input => { input.checked = consent[input.dataset.btCookie] === 'yes'; });
    panel.hidden = false;
  };
  reopen.addEventListener('click', () => {
    if (!privacy) return;
    if (window.privacyBanner?.showPreferences) {
      window.privacyBanner.showPreferences();
      return;
    }
    returnFocus = reopen;
    show();
    panel.querySelector('summary').focus();
  });
  buttons.forEach(button => button.addEventListener('click', () => {
    if (!privacy) return;
    const mode = button.dataset.btCookieSave;
    const consent = Object.fromEntries(controls.map(input => [input.dataset.btCookie, mode === 'custom' ? input.checked : mode === 'all']));
    errorText.hidden = true;
    buttons.forEach(item => { item.disabled = true; });
    const finish = success => {
      buttons.forEach(item => { item.disabled = false; });
      if (success) {
        panel.hidden = true;
        if (returnFocus) returnFocus.focus();
      } else errorText.hidden = false;
    };
    try {
      privacy.setTrackingConsent(consent, result => {
        const saved = privacy.currentVisitorConsent();
        finish(!result?.error && Object.entries(consent).every(([key,value]) => saved[key] === (value ? 'yes' : 'no')));
      });
    } catch { finish(false); }
  }));
  const initializePrivacy = () => {
    privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return;
    reopen.hidden = false;
    if (window.privacyBanner?.showPreferences) return;
    const consent = privacy.currentVisitorConsent();
    if (['preferences','analytics','marketing'].some(key => consent[key] !== 'yes' && consent[key] !== 'no')) show();
  };
  const loadPrivacy = () => {
    if (window.Shopify?.customerPrivacy) initializePrivacy();
    else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}], error => { if (!error) initializePrivacy(); });
  };
  if (document.readyState === 'complete') loadPrivacy();
  else window.addEventListener('load', loadPrivacy, {once:true});
})();
